import { Table, TableThProps } from '@mantine/core';
import clsx from 'clsx';
import { forwardRef } from 'react';

export type RegistryTableThProps = TableThProps;

export const createRegistryTableTh = () => {
	const RegistryTableTh = forwardRef<HTMLTableCellElement, RegistryTableThProps>(
		({ className, ...props }, ref) => (
			<Table.Th
				ref={ref}
				className={clsx('registry-table-th', className)}
				{...props}
			/>
		),
	);

	return RegistryTableTh;
};
